module.exports = __webpack_public_path__ + "img/a5033e9.png";